import { IClassname } from '@/lib/shared/model/classname';

export const Speaker = ({ className }: IClassname) => {
  return (
    <svg
      width="32"
      className={className}
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.17934 21.751C4.24254 21.751 4.3043 21.7698 4.35683 21.8048C4.40937 21.8399 4.45032 21.8898 4.4745 21.9482C4.49868 22.0066 4.50501 22.0708 4.49269 22.1328C4.48036 22.1948 4.44993 22.2517 4.40525 22.2964C4.36056 22.341 4.30365 22.3714 4.24167 22.3838C4.1797 22.3961 4.11546 22.3898 4.05708 22.3657C3.99871 22.3414 3.94881 22.3005 3.9137 22.248C3.8786 22.1954 3.85986 22.1336 3.85986 22.0705C3.85986 21.9857 3.89352 21.9045 3.95343 21.8445C4.01335 21.7846 4.09462 21.751 4.17934 21.751Z"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.17934 26.2236C4.24254 26.2236 4.3043 26.2424 4.35683 26.2774C4.40937 26.3126 4.45032 26.3624 4.4745 26.4208C4.49868 26.4792 4.50501 26.5435 4.49269 26.6055C4.48036 26.6675 4.44993 26.7243 4.40525 26.769C4.36056 26.8136 4.30365 26.8441 4.24167 26.8565C4.1797 26.8687 4.11546 26.8625 4.05708 26.8383C3.99871 26.814 3.94881 26.7731 3.9137 26.7206C3.8786 26.6681 3.85986 26.6062 3.85986 26.5431C3.85986 26.4584 3.89352 26.3771 3.95343 26.3172C4.01335 26.2572 4.09462 26.2236 4.17934 26.2236Z"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.4181 19.1943H2.58187C1.8761 19.1943 1.30396 19.7665 1.30396 20.4723V28.1398C1.30396 28.8455 1.8761 29.4177 2.58187 29.4177H29.4181C30.1239 29.4177 30.696 28.8455 30.696 28.1398V20.4723C30.696 19.7665 30.1239 19.1943 29.4181 19.1943Z"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.1117 21.751H8.33256C7.97968 21.751 7.6936 22.0371 7.6936 22.3899V24.3068C7.6936 24.6596 7.97968 24.9458 8.33256 24.9458H21.1117C21.4646 24.9458 21.7507 24.6596 21.7507 24.3068V22.3899C21.7507 22.0371 21.4646 21.751 21.1117 21.751Z"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.2233 26.2234C27.2819 26.2234 28.1401 25.3652 28.1401 24.3065C28.1401 23.2479 27.2819 22.3896 26.2233 22.3896C25.1646 22.3896 24.3064 23.2479 24.3064 24.3065C24.3064 25.3652 25.1646 26.2234 26.2233 26.2234Z"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.13778 2.58203H10.2494C10.5884 2.58203 10.9134 2.71667 11.1531 2.95632C11.3927 3.19598 11.5274 3.52102 11.5274 3.85995V19.1949H3.85986V3.85995C3.85986 3.52102 3.9945 3.19598 4.23415 2.95632C4.47381 2.71667 4.79885 2.58203 5.13778 2.58203Z"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.85986 13.4443H11.5274"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.7506 2.58203H26.8622C27.2011 2.58203 27.5262 2.71667 27.7659 2.95632C28.0055 3.19598 28.1402 3.52102 28.1402 3.85995V19.1949H20.4727V3.85995C20.4727 3.52102 20.6073 3.19598 20.847 2.95632C21.0866 2.71667 21.4117 2.58203 21.7506 2.58203Z"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.4727 13.4443H28.1402"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.6935 16.639C7.51706 16.639 7.37402 16.496 7.37402 16.3195C7.37402 16.143 7.51706 16 7.6935 16"
        stroke="#22364A"
        strokeWidth="1.33"
      />
      <path
        d="M7.6936 16.639C7.87005 16.639 8.01308 16.496 8.01308 16.3195C8.01308 16.143 7.87005 16 7.6936 16"
        stroke="#22364A"
        strokeWidth="1.33"
      />
      <path
        d="M24.3065 16.639C24.1301 16.639 23.9871 16.496 23.9871 16.3195C23.9871 16.143 24.1301 16 24.3065 16"
        stroke="#22364A"
        strokeWidth="1.33"
      />
      <path
        d="M24.3066 16.639C24.4831 16.639 24.6261 16.496 24.6261 16.3195C24.6261 16.143 24.4831 16 24.3066 16"
        stroke="#22364A"
        strokeWidth="1.33"
      />
    </svg>
  );
};
